__turbopack_context__.v({
  "arrow": "HeroCard-module__dIrRea__arrow",
  "block": "HeroCard-module__dIrRea__block",
  "card": "HeroCard-module__dIrRea__card",
  "content": "HeroCard-module__dIrRea__content",
  "description": "HeroCard-module__dIrRea__description",
  "flip": "HeroCard-module__dIrRea__flip",
  "icon": "HeroCard-module__dIrRea__icon",
  "level": "HeroCard-module__dIrRea__level",
  "levelIcon": "HeroCard-module__dIrRea__levelIcon",
  "portrait": "HeroCard-module__dIrRea__portrait",
  "powerCount": "HeroCard-module__dIrRea__powerCount",
  "specialty1": "HeroCard-module__dIrRea__specialty1",
  "specialty4": "HeroCard-module__dIrRea__specialty4",
  "specialty6": "HeroCard-module__dIrRea__specialty6",
  "spellContainer": "HeroCard-module__dIrRea__spellContainer",
  "spellOptions": "HeroCard-module__dIrRea__spellOptions",
  "spellOptionsIcon": "HeroCard-module__dIrRea__spellOptionsIcon",
  "spellOptionsText": "HeroCard-module__dIrRea__spellOptionsText",
  "spellPowerIcon": "HeroCard-module__dIrRea__spellPowerIcon",
  "unitIcon": "HeroCard-module__dIrRea__unitIcon",
  "unitStats": "HeroCard-module__dIrRea__unitStats",
});
